import React from 'react';
import { useTranslation } from 'react-i18next';

import { ResponsiveModalBottomSheet, Button } from '@/components';
import { useBrandStore } from '@/store';

interface CancellationPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
}

const CancellationPolicyModal: React.FC<CancellationPolicyModalProps> = ({
  isOpen,
  onClose,
  onAccept,
}) => {
  const { t, i18n } = useTranslation();
  const { getCancellationPolicy } = useBrandStore();

  const currentLanguage = i18n.language as 'en' | 'th';
  const cancellationContent = getCancellationPolicy(currentLanguage);

  return (
    <ResponsiveModalBottomSheet
      heightClass="h-[85vh]"
      isOpen={isOpen}
      onClose={onClose}
      title={t('cancellation.title')}
      stickyFooter={
        <div className="p-4">
          <Button onClick={onAccept}>{t('cancellation.accept')}</Button>
        </div>
      }
    >
      <div className="px-4 py-4 pt-2">
        {/* Cancellation Policy Content */}
        <div className="leading-6 text-secondary-text">
          <div
            className="prose prose-sm max-w-none [&_li]:mb-2 [&_ul]:ml-6 [&_ul]:list-disc"
            dangerouslySetInnerHTML={{
              __html: cancellationContent
                .replace(/\n/g, '<br />')
                .replace(/\*\s/g, '<li>')
                .replace(/<li>/g, '</li><li>')
                .replace(/^<\/li>/, '')
                .replace(/<li>$/, '</li>'),
            }}
          />
        </div>
      </div>
    </ResponsiveModalBottomSheet>
  );
};

export default CancellationPolicyModal;
